export default "__VITE_ASSET__46d95496__"